import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { SliderItem } from 'src/app/models';
import { DynamicComponent } from '../../../../base/dynamic.component';
import { PluginService } from '../../../../../services/plugin.service';
@Component({
    selector: 'table-item-component',
    templateUrl: 'table.item.component.html',
    styles: [` .mat-cell {
                  cursor: pointer;
                }`
    ],
})
export class TableSectionItemComponent extends DynamicComponent implements OnInit {

    constructor(public pluginService: PluginService) {
        super(pluginService);
    }

    @Input() value: any = [];

    @Output() valueChange = new EventEmitter<any>();
    
    @Output() delete = new EventEmitter();

    column_number: number;
    row_number: number;
    // number_arr = Array(20).fill("").map((x, i) => i + 1);
    number_arr_row = Array(100).fill("").map((x, i) => i + 1);
    number_arr_column = Array(20).fill("").map((x, i) => i + 1);

  	dataSource = [];
  	columns: Array<any> = [];
	displayedColumns: string[] = [];
    defaultRowIndex: number;

    ngOnInit() {
        console.log(this.dataSource);
       if(this.value && this.value.length)
          {
          var columnNum = Object.keys(this.value[1]).length;
          
          for (var i = 0; i < columnNum ; i++)
          this.columns.push({ name: 'field' + i, label: 'field' + i});
        
          this.displayedColumns = this.columns.map(column => column.name);            
          this.dataSource = this.value;   
          }
       
    }

    update(element, comment: string, row_index: number, column_index: number){       
        if(comment)
        {        
        var row_data = this.dataSource[row_index];
        row_data['field' + column_index] = comment;
        this.dataSource[row_index] = row_data;        
        
        this.valueChange.emit(this.dataSource);
        }    
    }

    generateTable(){
    if(!(this.column_number && this.row_number)) { alert('Please provide column or row number'); return;}   

    var tmp_arr: any = [];
    var tmp_arr_sub: any = [];
    var tmp_obj;

    for (var i = 0; i < this.column_number ; i++)
    tmp_arr_sub['field' + i] = 'value';
    
    tmp_obj = Object.assign({}, tmp_arr_sub);

    for (var i = 0; i < this.row_number ; i++)
    tmp_arr.push(tmp_obj);

    tmp_arr = JSON.parse(JSON.stringify(tmp_arr));    

    this.columns = [];
    for (var i = 0; i < this.column_number ; i++)
    this.columns.push({ name: 'field' + i, label: 'field' + i});

    this.displayedColumns = this.columns.map(column => column.name);            
    

    if(this.dataSource.length !== 0)
    {
        for (var i = 0; i < this.row_number ; i++)
            for (var j = 0; j < this.column_number ; j++)
            {
                if ((typeof this.dataSource[i] !== 'undefined') && (typeof this.dataSource[i]["field" + j] !== 'undefined'))
                tmp_arr[i]["field" + j] = this.dataSource[i]["field" + j];
            }
    }
    this.dataSource = tmp_arr;   
       
    this.valueChange.emit(this.dataSource);
    };

   
}